import { RECEIVE_CUSTOM_POSTS } from '../actions'

export const DEFAULT_CUSTOM_POST = 'defaultPost'

let defaultCustomPost = [{
    id: '',
    content: {
        rendered: ''
    },
    title: {
        rendered: ''
    },
    slug: '',
    type: '',
    featured_media: '',
    categories: [],
    cmb2: {
        _training_intro_metabox: {
            _training_intro_text: '',
            _training_intro_excerpt: '',
        },
        _training_quote_metabox: {
            _training_quote_text: '',
            _training_quote_author: '',
        },
        _training_film_metabox: {
            _training_film_id: '',
        },
    },
}]

let defaultState = {
    [DEFAULT_CUSTOM_POST]: defaultCustomPost
}

export default function posts(state = defaultState, action) {
    switch(action.type) {
        case RECEIVE_CUSTOM_POSTS:
            const { posts, postType } = action.payload
            return Object.assign({}, state, {
                [postType]:posts
            });

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/customposts.js